export const downloadUrl = ({ name, url }) => {
  const link = document.createElement('a')
  link.href = url
  link.download = name
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const downloadBlob = (response) => {
  const disposition = response.headers['content-disposition']

  const name = /filename=(.*?)(;|$)/.exec(disposition)[1]

  const url = URL.createObjectURL(
    new Blob([response.data], {
      type: response.headers['content-type']
    })
  )

  downloadUrl({ name, url })

  URL.revokeObjectURL(url)
}
